export const VISA = 'VISA';
export const MASTERCARD = 'MASTERCARD';
export const AMEX = 'AMEX';
export const DISCOVER = 'DISCOVER';
